import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Entry } from 'contentful';
import { Article } from '../../_models/article.model';
import { Theme } from '../../_models/theme.model';
import { Asset } from "contentful";


@Component({
  selector: 'app-articles',
  standalone: false,
  templateUrl: './articles.component.html',
  styleUrl: './articles.component.css'
})
export class ArticlesComponent {
  @Input() articlesContent: Array<Entry<Article>> | undefined;
  @Input() themeContent: Entry<Theme> | undefined;



  constructor(
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {

  }

  getImageArray(image: { [x: string]: undefined } | any[]): Array<Asset> {

    if (Array.isArray(image)) {
      return image;
    }
    
    if (image && typeof image === 'object') {
      return Object.values(image).filter(item => item !== undefined);
    }
    
    return [];
  }

  getSafeImageUrl(imageURL: string): SafeUrl {
    const url = `https:${imageURL}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

ElementFocus(id: string) {
    var elemento = document.getElementById(id);
    if (elemento) {
        elemento.scrollIntoView({ behavior: 'smooth' });
        elemento.focus();
    }
}


}
